import { render, staticRenderFns } from "./RequiredDocumentsPopup.vue?vue&type=template&id=c1b2b60c&"
import script from "./RequiredDocumentsPopup.vue?vue&type=script&lang=js&"
export * from "./RequiredDocumentsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports